var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "5px",
    viewBox: "0 0 9 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conversion-Calculator-(No-New-Rate)",
    transform: "translate(-1250.000000, -29.000000)",
    fill: "#4A5866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Bar",
    transform: "translate(-12.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Building-Profile",
    transform: "translate(1119.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145,4.8051256 L145,12.1912974 C145,12.9081669 145.819113,13.270629 146.296928,12.7631821 L149.778157,9.06606879 C150.073948,8.75193498 150.073948,8.24448806 149.778157,7.93035425 L146.296928,4.23324098 C145.819113,3.73384877 145,4.08825614 145,4.8051256 Z",
    id: "Path",
    transform: "translate(147.500000, 8.500000) rotate(90.000000) translate(-147.500000, -8.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownGrey);
export default __webpack_public_path__ + "static/media/dropdown-grey.86c1c3c0c0bf0b8051640f6594dcd1e4.svg";
export { ForwardRef as ReactComponent };